import { effect, inject, Injectable, model, signal } from "@angular/core";
import { WsService } from "./ws.service";
import { ApiService, IFile } from "./api.service";
import { concatMap, Observable, Subject, tap } from "rxjs";
import { LoadingService } from "./loading.service";
import { HttpEventType } from "@angular/common/http";
import { HelpersService } from "./helpers.service";
import { AuthService } from "./auth.service";
import { BaseEventsReceiver } from "./messages-receivers/base-events-receiver";
import { ChatReceiver } from "./messages-receivers/chat-receiver";
import { DisputeReceiver } from "./messages-receivers/dispute-receiver";


@Injectable({
  providedIn: 'root'
})
export class MessagesService {
    wsService = inject(WsService);

    messageQueueWS = this.wsService.messageQueue;

    chatReceiver = new ChatReceiver();
    disputeReceiver = new DisputeReceiver();

    messageEffect = effect(() => {
        const queue = this.messageQueueWS();
        if (queue.length === 0) return;
        for (const message of queue) {
            if (message?.event === 'NEW_MESSAGE' ) {
               this.chatReceiver.receiveMessage(
                this.chatReceiver.incomingEventToIMessage(message))
            } else if (message?.event === 'NEW_DISPUTE_MESSAGE') {
                this.disputeReceiver.receiveMessage(this.disputeReceiver.incomingEventToIMessage(message))
            }
        }
        this.wsService.messageQueue.set([]);
    });
}